import { useDataChange } from 'Simple/Data.js'

export function isChecked(value) {
  return value === 'HIDDEN'
}

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'type',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(value ? 'HIDDEN' : 'PUBLIC')
  }
}
